import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { FormField } from './form-field';

export class Form extends BaseEntity{
    
    formCode    : string;
    name        : string;
    formFields  : FormField[];

}